import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "window" }
const _hoisted_2 = {
  key: 0,
  class: "header",
  style: {}
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  class: "icon",
  style: {"display":"flex","padding-right":"10px"}
}
const _hoisted_5 = {
  key: 0,
  class: "icon-icon_error"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "path3" }, null, -1)
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "icon-icon_warning"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 2,
  class: "icon-icon_info"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "path3" }, null, -1)
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "title align-self-center" }
const _hoisted_20 = { class: "body mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tirscript3_button = _resolveComponent("tirscript3-button")!
  const _component_bs_col = _resolveComponent("bs-col")!
  const _component_bs_row = _resolveComponent("bs-row")!

  return (_ctx.innerVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "tirscript-modal-window",
        id: "modal-wrapper",
        onMouseup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.mouseUpWrapper && _ctx.mouseUpWrapper(...args))),
        onMousedown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.mouseDownWrapper && _ctx.mouseDownWrapper(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.showHeaderTitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "header", {}, () => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["name", _ctx.icon])
                  }, [
                    (_ctx.iconImg)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "icon-img",
                          src: _ctx.iconImg
                        }, null, 8, _hoisted_3))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_4, [
                      (_ctx.type == 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _hoisted_9))
                        : _createCommentVNode("", true),
                      (_ctx.type == 3)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _hoisted_13))
                        : _createCommentVNode("", true),
                      (_ctx.type == 4)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _hoisted_18))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.title), 1)
                  ], 2)
                ]),
                (_ctx.showCloseBtn)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "bnt-close",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeWindow && _ctx.closeWindow(...args)))
                    }, " × "))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_20, [
            _renderSlot(_ctx.$slots, "default"),
            (!_ctx.noButton)
              ? _renderSlot(_ctx.$slots, "button", { key: 0 }, () => [
                  _createVNode(_component_bs_row, { class: "pb-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_bs_col, { class: "d-flex justify-content-end" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_tirscript3_button, {
                            style: {"margin-right":"5px"},
                            onOnClick: _ctx.onCancel,
                            width: 100,
                            active: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.textButtonDefault.cancel), 1)
                            ]),
                            _: 1
                          }, 8, ["onOnClick"]),
                          _createVNode(_component_tirscript3_button, {
                            onOnClick: _ctx.onOk,
                            width: 100
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.textButtonDefault.ok), 1)
                            ]),
                            _: 1
                          }, 8, ["onOnClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              : _createCommentVNode("", true)
          ])
        ])
      ], 32))
    : _createCommentVNode("", true)
}